import { NumberKit } from '@team/number';
import { isEmpty } from './is-empty.js';
import { HEAD_ELEMENT_INDEX } from './const.js';

export function getRandomElement<T>(array: T[]): Nullable<T> {
  if (isEmpty(array)) {
    return null;
  }

  const randomIndex = NumberKit.createRandomInt(
    HEAD_ELEMENT_INDEX,
    array.length - 1
  );

  const randomElement = array[randomIndex];

  if (!array.includes(randomElement)) {
    return null;
  }

  return randomElement;
}
